import { useEffect } from 'react';
import { Center, Loader } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@workos-inc/authkit-react';
import { SignInUnavailable } from '~portal/components';
import { useSignInRedirect } from '~portal/hooks';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const { isLoading, user } = useAuth();
  const navigate = useNavigate();
  const { failed, retry } = useSignInRedirect(!isLoading && !user);

  useEffect(() => {
    if (isLoading || !user) return;
    void navigate({ to: '/' });
  }, [isLoading, user, navigate]);

  if (failed) return <SignInUnavailable onRetry={retry} />;

  return (
    <Center h="100vh">
      <Loader size="lg" />
    </Center>
  );
}
